import type { StackProps } from '@/components/layout/Stack';

export type TitleWithIconIconVariantsSet = {
  base?: TitleWithIconIconVariants;
  sm?: TitleWithIconIconVariants;
  md?: TitleWithIconIconVariants;
  lg?: TitleWithIconIconVariants;
  xl?: TitleWithIconIconVariants;
};

export type TitleWithIconSizeOptions = 'sm' | 'md' | 'lg';
export type TitleWithIconIconVariants = 'standard' | 'large';
export type TitleWithIconComponentVariants = 'component' | 'block';
type IllustrativeIconSizes = 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export const iconSpacing = (
  size: TitleWithIconSizeOptions,
  variant: TitleWithIconComponentVariants,
): StackProps['spacing'] => {
  const spacing: Record<
    TitleWithIconComponentVariants,
    Record<TitleWithIconSizeOptions, StackProps['spacing']>
  > = {
    block: {
      lg: '--space-component-xxl',
      md: '--space-component-xl',
      sm: '--space-component-xl',
    },
    component: {
      lg: '--space-component-lg',
      md: '--space-component-lg',
      sm: '--space-component-lg',
    },
  };

  return spacing[variant][size];
};

export const iconSize = (
  size: TitleWithIconSizeOptions,
  variant: TitleWithIconComponentVariants,
  iconVariant: TitleWithIconIconVariants,
) => {
  const sizeMap: Record<
    TitleWithIconSizeOptions,
    Record<
      TitleWithIconComponentVariants,
      Record<TitleWithIconIconVariants, IllustrativeIconSizes>
    >
  > = {
    lg: {
      block: {
        large: '3xl',
        standard: 'xl',
      },
      component: {
        large: 'md',
        standard: 'sm',
      },
    },
    md: {
      block: {
        large: '2xl',
        standard: 'lg',
      },
      component: {
        large: 'md',
        standard: 'sm',
      },
    },
    sm: {
      block: {
        large: 'xl',
        standard: 'md',
      },
      component: {
        large: 'md',
        standard: 'sm',
      },
    },
  };

  return sizeMap[size][variant][iconVariant];
};

export const iconProperties = {
  '3xl': {
    strokeWidth: '2.5px',
    size: '56px',
  },
  '2xl': {
    strokeWidth: '2.5px',
    size: '48px',
  },
  xl: {
    strokeWidth: '2px',
    size: '40px',
  },
  lg: {
    strokeWidth: '2px',
    size: '32px',
  },
  md: {
    strokeWidth: '1.5px',
    size: '28px',
  },
  sm: {
    strokeWidth: '1.5px',
    size: '24px',
  },
};
